module.exports = __webpack_public_path__ + "img/facebook.afe3725e.png";